import React, { useState } from "react";
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";
import TimeLineComponent from "./TimeLineComponent";

const ImageSlider = ({ slides, handleImageSelection }) => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }

  return (
    <>
      <section className="slider">
        {length > 1 && (
          <FaArrowAltCircleLeft className="left-arrow" onClick={prevSlide} />
        )}
        {length > 1 && (
          <FaArrowAltCircleRight className="right-arrow" onClick={nextSlide} />
        )}

        {slides.map((slide, index) => {
          return (
            <div
              className={index === current ? "slide active" : "slide"}
              key={index}
            >
              {index === current && (
                <img
                  src={slide.image}
                  alt="travel image"
                  className="image"
                  onClick={() => handleImageSelection(index)}
                />
              )}
            </div>
          );
        })}
      </section>
      {length > 1 && (
        <div className="row ml-0 mr-0 mt-5 d-flex justify-content-center">
          <TimeLineComponent totalLength={length} activeStep={current} />
        </div>
      )}
    </>
  );
};

export default ImageSlider;
